// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2L0fj","Open":"SideDrawer_Open__31Ygy","Close":"SideDrawer_Close__1C0Zd","Logo":"SideDrawer_Logo__3wCZu"};